import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Chatroom, Group } from "../../class/chatroom";
import { GroupProvider } from "../../providers/group/group";
import { UtilProvider } from "../../providers/util/util";
import { CustomLoadingProvider } from "../../providers/custom-loading/custom-loading";

/**
 * Generated class for the ChooseChatroomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-choose-chatroom",
  templateUrl: "choose-chatroom.html"
})
export class ChooseChatroomPage {

  //数据源
  group_list: Array<Group>;
  client_list:  Array<any>;
  //已经选择的微信群
  choosed_chatroom_list: Array<any>;
  choosed_client_list: Array<any>;
  //保存时传值回去的回调方法
  saveChatroom;
  //单选模式（只能选择一个群）
  singleMode: boolean;
  //本次不可选的群
  disabledChatrooms: Array<any>;
  canClick: boolean = false;
  showChild:boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public groupService: GroupProvider,
    public util: UtilProvider,
    private csLoader: CustomLoadingProvider
  ) {
    this.choosed_chatroom_list = this.navParams.data["chatroom_list"] || [];
    this.saveChatroom = this.navParams.data["saveChatroom"];
    this.singleMode = this.navParams.data["singleMode"] || false;
    this.choosed_client_list = this.navParams.data["client_list"] || [];
    this.disabledChatrooms = this.navParams.data["disabled_chatrooms"] || [];
    this.showChild = this.navParams.data['showChild'];
    console.log(this.disabledChatrooms, this.navParams);
  }

  ionViewDidLoad() {
  }

  ionViewDidEnter() {
    this.getGroupList();
  }

  getGroupList() {
    this.csLoader.showLoader();
    this.groupService.getGroupList().subscribe(res => {
      this.csLoader.dismissLoader();

      this.group_list = res["content"]["group_list"]
        .filter(item => item.chatroom_list && item.chatroom_list.length);
      this.group_list.forEach(item => {
        item.chatroom_list = item.chatroom_list.filter(chatroom => {
          return chatroom.is_work == 1;
        });
      });
      this.group_list.forEach(group => {
        group.chatroom_list.forEach(item => {
          //给已经选中的群打勾
          if (this.choosed_chatroom_list.some(
            chatroom => chatroom.chatroomname == item.chatroomname)) {
            item.checked = true;
          } else {
            item.checked = false;
          }
          //给disabled 的群灰掉
          if (this.disabledChatrooms.some(
            chatroom => chatroom.chatroomname == item.chatroomname)) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
        //给组里全部chatroom disabled的组灰掉
        if (group.chatroom_list.every(chatroom => chatroom.disabled)) group.disabled = true;
      });
      this.client_list = res["content"]["confirmed_children_info"];
      this.client_list.forEach(item => {
          if (this.choosed_client_list.some(
            client => client.client_id == item.client_id)) {
            item.checked = true;
          } else {
            item.checked = false;
          }
      });
    }, err => {
      this.csLoader.dismissLoader();
    });
  }

  toggleShowGroup(group) {
    group.shown = !group.shown;
    if (group.shown) {
      this.group_list.forEach(value => {
        if (value.group_id != group.group_id) value.shown = false;
      });
    }
  }

  saveChoose() {
    let chatrooms = [];
    let clientList = [];
    this.group_list.forEach(group => {
      chatrooms = chatrooms.concat(
        group.chatroom_list.filter(item => item.checked)
      );
    });
    this.client_list.forEach(client => {
      if (client.checked) {
        clientList.push(client)
      }
    });
    this.saveChatroom(chatrooms, clientList);

    this.util.goBack(this.navCtrl);
  }

  getGroupCheckedChatroom(group) {
    return group.chatroom_list.filter(chatroom => chatroom.checked);
  }

  errorChatroomAvatar(chatroom) {
    chatroom.avatar_url = "./assets/imgs/group_nor.jpg";
  }

  onGroupClicked(group) {
    if (group.disabled) {
      group.canClick = "block";
    }
    let targetList = group.chatroom_list.filter(chatroom => {
      return !this.disabledChatrooms.some(value => value.chatroomname == chatroom.chatroomname);
    });
    targetList.forEach(chatroom => chatroom.checked = group.checked);
  }

  onChatroomClicked(chatroom, group) {
    //如果是单选模式
    if (this.singleMode) {
      if (chatroom.checked) {
        this.group_list.forEach(value => {
          value.chatroom_list.forEach(value2 => {
            if (chatroom.chatroomname != value2.chatroomname) value2["checked"] = false;
          });
        });
      } else {
        setTimeout(() => {
          chatroom.checked = true;
        }, 0);

      }
    } else {  //如果是多选模式
      if (chatroom.checked && group.chatroom_list.every(chatroom => chatroom.checked)) {
        group.checked = true;
      } else {
        group.checked = false;
      }
    }
  }

  noChooseTips() {
    this.canClick = true;
    setTimeout(() => {
      this.canClick = false;
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/choose-chatroom/choose-chatroom.ts